import { supabase } from "./supabase";

// Avisa MANUTENÇÃO / COMBUSTÍVEL / RASTREAMENTO que a ficha andou.
//
// Os tres expoem os MESMOS caminhos de integracao; o `sistema` so escolhe a
// URL e a chave do outro lado. A ficha ja grava em quais deles o parceiro
// entra (campo `sistemas`), e a tela avisa um por um.
//
// Regra que vale para as duas chamadas: **isto nunca bloqueia o CRM**. A ficha
// já está salva no Supabase quando estas funções rodam; se a manutenção estiver
// fora do ar, a falha fica registrada em `credenciamentos.manutencao_sync` e a
// equipe reenvia por um botão. O fornecedor não vê erro de integração.
//
// A chave de integração nunca chega aqui — quem fala com o Rails é a função
// serverless api/frota-sync.js. Daqui vai só o id da ficha.

const ENDPOINT = "/api/frota-sync";

async function chamar(body, comSessao) {
  const headers = { "Content-Type": "application/json" };
  if (comSessao) {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  }
  try {
    const res = await fetch(ENDPOINT, { method: "POST", headers, body: JSON.stringify(body) });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) return { ok: false, erro: json.error || "Falha ao avisar o sistema de manutenção." };
    return json;
  } catch {
    return { ok: false, erro: "Falha ao avisar o sistema de manutenção." };
  }
}

/**
 * Fornecedor enviou a ficha → garante o cadastro dele na manutenção e traz o
 * link de documentos DELE. Sem aceite: ninguém conferiu a ficha ainda.
 *
 * `editToken` autentica pela ficha, não pela pessoa: quem preenche pelo link é
 * anônimo. Da equipe (logada) ele não é necessário.
 */
export function sincronizarCadastro(fichaId, editToken, sistema = "manutencao") {
  return chamar({ acao: "cadastro", ficha_id: fichaId, sistema, edit_token: editToken || undefined }, !editToken);
}

/**
 * Equipe concluiu a ficha → grava o aceite lá e anexa o PDF unificado, que só
 * existe a partir do "Concluir". Exige usuário logado.
 */
export function sincronizarAceite(fichaId, sistema = "manutencao") {
  return chamar({ acao: "aceite", ficha_id: fichaId, sistema }, true);
}

/**
 * Consulta de leitura pelo CNPJ (api/frota). Devolve o que a manutenção sabe
 * do fornecedor: se existe, o que falta de documento e o link de upload.
 */
export async function consultarVinculo(cnpj, sistema = "manutencao") {
  const d = String(cnpj || "").replace(/\D/g, "");
  if (d.length !== 14) return { configured: true, found: false, invalid: true };
  const { data: { session } } = await supabase.auth.getSession();
  try {
    const res = await fetch("/api/frota", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${session?.access_token || ""}` },
      body: JSON.stringify({ cnpj: d, sistema }),
    });
    const json = await res.json();
    return res.ok ? json : { error: json.error || "Falha na consulta." };
  } catch {
    return { error: "Falha ao consultar o sistema de manutenção." };
  }
}

/**
 * Documentos que a manutenção ainda espera deste CNPJ.
 * `null` = não deu para saber (manutenção fora, CNPJ inválido, fornecedor
 * inexistente).
 *
 * Sem uso hoje: quem consultava era o "Concluir credenciamento", para bloquear
 * a conclusão quando faltava documento — e isso deixou de existir (os
 * documentos da empresa não travam mais o fluxo). A tela do vínculo mostra a
 * mesma lista pela `consultarVinculo`. Fica disponível para consulta pontual;
 * quem usar NÃO deve bloquear nada em cima de `null`.
 */
export async function documentosPendentes(cnpj, sistema = "manutencao") {
  const d = await consultarVinculo(cnpj, sistema);
  if (!d?.found || d.error) return null;
  return Array.isArray(d.docs_faltantes) ? d.docs_faltantes : [];
}

// Mensagem do WhatsApp com o link de documentos (mesmo texto do card da ficha)
export function whatsappDocumentos(telefone, url) {
  const d = String(telefone || "").replace(/\D/g, "");
  const base = d ? `https://wa.me/${d.length <= 11 ? "55" + d : d}` : "https://wa.me/";
  const texto = `Olá! Para concluir seu credenciamento na InstaSolutions, envie os documentos por aqui (o link expira em 7 dias):\n${url}`;
  return `${base}?text=${encodeURIComponent(texto)}`;
}
